import { ArrowLeftIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import { ROUTES } from "utils/constants";

import Button from "components/Button";
import Container from "components/Container";
import Content from "components/Content";
import Header from "components/Header";
import MainMenu from "components/MainMenu";

import ReportTemplateCard from "./ReportTemplateCard";
import useReportTemplates from "./useReportTemplates";

export default function ReportTemplates() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { reportTemplates, isLoadingReportTemplates } = useReportTemplates();

  return (
    <>
      <Header className="justify-between">
        <div className="flex items-center gap-2">
          <Link to={ROUTES.PROFILE} className="flex items-center cursor-pointer">
            <ArrowLeftIcon />
          </Link>
          {t("menu.reportTemplates")}
        </div>
        <MainMenu />
      </Header>
      <Content isLoading={isLoadingReportTemplates}>
        {reportTemplates && reportTemplates.length > 0 ? (
          <Container className="p-4">
            <div className="pt-5 flex flex-col gap-2.5">
              <p>{t("profile.reportTemplates.title")}</p>
              <Button variant="primary" asChild>
                <Link className="my-4" to={ROUTES.PROFILE_REPORT_TEMPLATE_NEW}>
                  {t("profile.reportTemplates.newReportTemplate")}
                </Link>
              </Button>
              <div className="flex flex-col gap-2.5">
                {reportTemplates.map((template) => (
                  <ReportTemplateCard reportTemplate={template} key={template.id} />
                ))}
              </div>
            </div>
          </Container>
        ) : (
          <Container className="flex flex-col justify-center py-16 gap-4 p-4">
            <div className="text-center">{t("profile.reportTemplates.noReportTemplatesAvailable")}</div>

            <Button type="button" className="w-full" onClick={() => navigate(ROUTES.PROFILE_REPORT_TEMPLATE_NEW)}>
              {t("profile.reportTemplates.newReportTemplate")}
            </Button>
          </Container>
        )}
      </Content>
    </>
  );
}
